export default __webpack_public_path__ + "static/media/loanimg.1990cac4.svg";